export const company = "VRCORE Education";
export const siteName = "VRCORE-Ed Portal";
export const colorPrimary = "#009CDE";
